import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/for-suppliers/page.tsx");
